import { selectAllStrings } from '../language/languageSlice';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PoiRating } from '../pois/PoiList';
import { handlePointerDown } from '../../lib/modal-helper';
import '../../stylesheets/AddReviewModal.css';
import ErrorModal from '../../app/ErrorModal';
import { addReview } from './reviewsSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import ConfirmModal from '../../app/ConfirmModal';
import { logEvent, EVENTS } from '../../lib/event-helper';

const ReviewModal = ({onGoBack, poiId, defaultRating=0, defaultReview='', reviewId=null}) => {
    const [error, setError] = useState('');
    const [successTitle, setSuccessTitle] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const strings = useSelector(selectAllStrings);
    const [rating, setRating] = useState(defaultRating);
    const [addRequestStatus, setAddRequestStatus] = useState('idle');
    
    
    const onReviewChanged = (event) => {
        setReview(event.target.value);
    };
    const [review, setReview] = useState(defaultReview);
    
    const canPost = rating && review && addRequestStatus === 'idle';
    let userId;
    if(defaultReview !== '') {
        userId = useSelector(state => state.reviews.reviewBeingEdited.pr_id);
    } else {
        userId = useSelector(state => state.user.cardData.profile_id);
    }
    
    const dispatch = useDispatch();
    const onPostClicked = async (event) => {
        event.preventDefault();
        if (canPost) {
            try {
                setAddRequestStatus('pending');
                const resultAction = await dispatch(addReview({userId, poiId, rating, review, reviewId}));
                unwrapResult(resultAction);
                if (resultAction.payload.valid == 1) {
                    logEvent(EVENTS.WRITE_REVIEW, userId, poiId);
                    logEvent(EVENTS.SEND_EVALUATION, userId, poiId);
                    setSuccessTitle(strings.thanks_for_review);
                    setSuccessMessage(strings.review_waiting);
                } else {
                    setError(resultAction.payload.message);
                    setReview('');
                    setRating(0);
                }
            } catch (err) {
                setError(err.message);
                setAddRequestStatus('failed');
            } finally {
                setAddRequestStatus('idle');
            }
        }
    };

    return (error ? <ErrorModal strings={strings} message={error} onClose={() => setError('')} /> :
            successMessage ? <ConfirmModal title={successTitle} message={successMessage} onClose={onGoBack}/> :
            <div className="modal" id="add_review_modal">
                <div className="modal-body" id="add_review_modal_body">
                    <div className="modal-border" onPointerDown={event => handlePointerDown(event, 'add_review_modal_body')}>
                        <div className="move-handler"></div>
                    </div>
                    <div className="modal-content">
                        <div className="modal-header" onPointerDown={event => handlePointerDown(event, 'add_review_modal_body')}>
            
                            <a className="close-modal" onPointerDown={event => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                   }} onClick={event => {
                                       event.preventDefault();
                                       onGoBack();
                                   }}></a>
                            <span onPointerDown={event => event.preventDefault()}>{strings.leave_review}</span>
                            <hr/>
                        </div>
                        <form onSubmit={onPostClicked}>
                        <div className="modal-title">{strings.rate_place}</div>
                        <PoiRating rating={rating} onClick={rating => setRating(rating)} validation={true}/>
                        
                            
                            <label>{strings.type_review}
                            <textarea id="review" required onChange={onReviewChanged} value={review} minLength="8"></textarea>
                            </label>
                            <button type="submit" className="btn" id="post_button">
                            {addRequestStatus === 'pending' ? <div className="loader"></div> : strings.post}
                            </button>
                        </form>
                    </div>
                </div>
            </div>);
};

export default ReviewModal;

